import React, { useState, useEffect } from 'react';
import { Search, FileText, FileSpreadsheet, FileDown } from 'lucide-react';
import { exportNotesToCSV, exportNotesToExcel, exportNotesToPDF } from './NotesExportService';
import api from '../api';

const NotesSearchBar = ({ 
  searchTerm, 
  setSearchTerm, 
  setCurrentPage, 
  filteredNotes, 
  controle 
}) => {
  const [etablissement, setEtablissement] = useState(null);

  // Charger les informations de l'établissement depuis l'API
  useEffect(() => {
    const loadEtablissement = async () => {
      try {
        const response = await api.get('/etablissement/etablissement-infos/');
        if (response.data) {
          console.log('Données établissement chargées pour notes:', response.data);
          setEtablissement(response.data);
        }
      } catch (error) {
        console.error('Erreur lors du chargement de l\'établissement:', error);
        // Fallback avec des données par défaut si l'API échoue
        const etablissementData = {
          libelle: "ÉTABLISSEMENT SCOLAIRE",
          nom: "ÉTABLISSEMENT",
          pays: "CAMEROUN",
          ministere: "L'ENSEIGNEMENT SUPÉRIEUR",
          devise: "Excellence et Savoir",
          email: "contact@etablissement.cm",
          contact: "+237 123 456 789",
          telephone: "+237 123 456 789",
          bp: "BP 1234",
          site_web: "www.etablissement.cm",
          adresse: "Adresse de l'établissement",
          logo_url: null // Pas de logo par défaut
        };
        setEtablissement(etablissementData);
      }
    };

    loadEtablissement();
  }, []);

  const handleExportCSV = () => {
    exportNotesToCSV(filteredNotes, controle, etablissement);
  };

  const handleExportExcel = () => {
    exportNotesToExcel(filteredNotes, controle, etablissement);
  };

  const handleExportPDF = () => {
    exportNotesToPDF(filteredNotes, controle, etablissement);
  };

  return (
    <div className="flex items-center space-x-3">
      {/* Barre de recherche */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
        <input
          type="text"
          placeholder="Rechercher..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
          className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-[#202654] focus:border-[#202654] w-64"
        />
      </div>
      
      {/* Boutons d'export */}
      <div className="flex space-x-2">
        <button
          onClick={handleExportCSV}
          className="inline-flex items-center px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
          title="Exporter en CSV"
        >
          <FileText className="h-4 w-4 mr-1" />
          CSV
        </button>
        <button
          onClick={handleExportExcel}
          className="inline-flex items-center px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
          title="Exporter en Excel"
        >
          <FileSpreadsheet className="h-4 w-4 mr-1" />
          Excel
        </button>
        <button
          onClick={handleExportPDF}
          className="inline-flex items-center px-3 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 transition-colors"
          title="Exporter en PDF"
        >
          <FileDown className="h-4 w-4 mr-1" />
          PDF
        </button>
      </div>
    </div>
  );
};

export default NotesSearchBar;